<template>
  <div class="payment-status">
    <div class="page__title">{{ $t("payment_status.title") }}</div>
    <div class="payment-status__content">
      <div class="payment-status__title">
        {{ $t("payment_status.error_title") }}
      </div>
      <div class="payment-status__sub-title">
        {{ $t("payment_status.check_requisites") }}
      </div>
      <div class="payment-status__amount">
        {{ $t("amount") }} {{ orderTotal }} {{ $t("currency") }}
      </div>
      <div class="payment-status__actions">
        <primary-button
          :text="$t('payment_status.action.back_to_payment')"
          @click="toPaymentWidgetUrl"
        ></primary-button>
        <transparent-button
          :text="$t('payment_status.action.create_payment')"
          @click="toCreatePaymentPage"
        ></transparent-button>
      </div>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/buttons/PrimaryButton";
import TransparentButton from "@/components/buttons/TransparentButton";
import { OrderApi } from "@/office/order/order-api";

import FileSaver from "file-saver";
export default {
  name: "PaymentStatus",
  components: { TransparentButton, PrimaryButton },
  props: ["id"],
  data() {
    return {
      order: null,
      widgetUrl: "",
      receiptLoading: false,
    };
  },
  created() {
    this.loadOrder();
  },
  computed: {
    orderTotal: function () {
      if (this.order) {
        return this.order.sum;
      }

      return 0;
    },
  },
  methods: {
    loadOrder() {
      new OrderApi()
        .loadOrder(this.id)
        .then((r) => {
          this.order = r.data.order;
        })
        .catch(() => {
          this.$router.push("/archive");
        });

      new OrderApi().updateOrderWidgetLink(this.id).then((r) => {
        this.widgetUrl = r.data.widget_url;
      });
    },
    loadOrderReceipts() {
      if (this.receiptLoading) {
        return;
      }

      this.receiptLoading = true;
      new OrderApi()
        .loadOrderReceipt(this.id)
        .then((r) => {
          FileSaver.saveAs(
            r.data,
            `${this.order.client.full_name}_${this.$moment(
              this.order.created_at
            ).format("DD.MM.YY hh:mm:ss")}.zip`
          );
        })
        .finally(() => {
          this.receiptLoading = false;
        });
    },
    toCreatePaymentPage() {
      this.$router.push("/");
    },
    toArchivePaymentsPage() {
      this.$router.push("/archive");
    },
    toPaymentWidgetUrl() {
      window.open(this.order.widget_url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";
.payment-status {
  margin-top: -50px;

  .page {
    &__title {
      margin-bottom: 26px;
    }
  }

  &__title {
    font-weight: 600;
    font-size: pxToRem(16);
    line-height: pxToRem(18);
    color: $red;
    margin-bottom: 20px;
  }

  &__sub-title {
    font-weight: 500;
    font-size: pxToRem(12);
    line-height: pxToRem(18);
    text-align: center;
    color: $text;
    margin-bottom: 20px;
  }

  &__amount {
    font-weight: bold;
    font-size: pxToRem(14);
    line-height: pxToRem(18);
    color: $text;
    margin-bottom: 35px;
  }

  &__content {
    padding: 32px;
    border-radius: 16px;
    border: 1px solid #f0f3fa;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__action {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #f0f3fa;
    border-radius: 16px;
    padding: 21px 25px;
    margin-bottom: 25px;

    &-icon {
      display: flex;
      align-items: center;
      justify-content: center;

      margin-right: 20px;
    }

    &-text {
      font-size: pxToRem(12);
      line-height: pxToRem(18);
      color: $text;
    }

    &--print {
      cursor: pointer;
      transition: opacity 0.2s linear;

      &.disabled {
        opacity: 0.8;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .primary-button {
    margin-bottom: 10px;
  }
}
</style>
